import { showWarning } from 'utils/utils';
import { faHeart } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC, Fragment, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { animate } from 'animejs';
import { faEnvelope } from '@fortawesome/pro-light-svg-icons';

interface ProposalHeartProps {
  active: boolean;
  onClickPropsal: (e: any) => void;
  disabledText?: string;
  isEnvelope?: boolean;
}

const ProposalHeart: FC<ProposalHeartProps> = ({
  active,
  onClickPropsal,
  disabledText,
  ...props
}) => {
  const { t } = useTranslation();
  const heartRef = useRef<HTMLDivElement>(null);
  const [isAnimating, setIsAnimating] = useState(false);

  const onClick = (e: any) => {
    if (isAnimating) return;

    if (disabledText) {
      showWarning(t(disabledText));
    } else {
      onClickPropsal(e);
      setTimeout(() => {
        setIsAnimating(false);
      }, 1000);

      if (heartRef.current) {
        setIsAnimating(true);

        if (heartRef.current.classList.contains('active')) {
          const proposalHeader = document.querySelector(
            window.innerWidth < 768 ? '.hamburger' : '#proposal-header'
          );

          const rect = proposalHeader?.getBoundingClientRect();
          const scaleCopy = heartRef.current.cloneNode(true) as HTMLDivElement;
          const backHeart = scaleCopy.querySelector('.pr-heart-back');
          if (backHeart) {
            backHeart.remove();
          }
          scaleCopy.classList.add('active');
          scaleCopy.style.position = 'fixed';
          scaleCopy.style.left = rect?.left + 'px';
          scaleCopy.style.top = rect?.top + 'px';
          scaleCopy.style.zIndex = '9998';
          scaleCopy.style.pointerEvents = 'none';
          scaleCopy.style.transform = 'scale(1)';
          scaleCopy.style.opacity = '1';

          document.body.appendChild(scaleCopy);

          animate(scaleCopy, {
            opacity: [1, 0],
            translateY: [0, 100],
            translateX: [0, 0],
            duration: 1000,
            easing: 'easeOutQuad',
            complete: () => {
              setTimeout(() => {
                scaleCopy.remove();
              }, 1000);
            },
          });
        } else {
          const copy = heartRef.current.cloneNode(true) as HTMLDivElement;
          const backHeart = copy.querySelector('.pr-heart-back');
          if (backHeart) {
            backHeart.remove();
          }
          const proposalHeader = document.querySelector(
            window.innerWidth < 768 ? '.hamburger' : '#proposal-header'
          );

          const rect = heartRef.current.getBoundingClientRect();
          copy.classList.add('active');
          copy.style.position = 'fixed';
          copy.style.left = rect.left + 'px';
          copy.style.top = rect.top + 'px';
          copy.style.zIndex = '9999';
          copy.style.pointerEvents = 'none';

          document.body.appendChild(copy);

          if (proposalHeader) {
            const headerRect = proposalHeader.getBoundingClientRect();
            animate(copy, {
              translateX: [0, headerRect.left - rect.left],
              translateY: [0, headerRect.top - rect.top],
              duration: 1000,
              easing: 'easeOutQuad',
              complete: () => {
                setTimeout(() => {
                  copy.remove();
                }, 1000);
              },
            });
          } else {
            animate(copy, {
              translateX: [0, window.innerWidth - rect.width - 50],
              translateY: [0, -rect.top - 50],
              duration: 1000,
              easing: 'easeOutQuad',
              complete: () => {
                setTimeout(() => {
                  copy.remove();
                }, 1000);
              },
            });
          }
        }
      }
    }
  };

  return (
    <Fragment>
      <div
        className={'pr-heart' + (active ? ' active' : '')}
        onClick={onClick}
        ref={heartRef}
      >
        {!props.isEnvelope && <FontAwesomeIcon icon={faHeart} className="pr-heart-back" />}

        <FontAwesomeIcon
          icon={props.isEnvelope ? faEnvelope : faHeart}
          className="pr-heart-front"
        />
      </div>
    </Fragment>
  );
};

export default ProposalHeart;
